import {useEffect, useRef} from '@wordpress/element';
import {useElements, useStripe} from "@stripe/react-stripe-js";
import {handleNextAction, isNextActionRequired} from "../util";

/**
 *
 * @param name
 * @param elementType - added this in version 3.3.89 so that the elements could be excluded from the handleNextAction method.
 * That's needed for the express checkout element since it captures shipping address data.
 * @param emitResponse
 * @param billingAddress
 * @param onCheckoutSuccess
 * @param activePaymentMethod
 */
export const useProcessCheckoutSuccess = (
    {
        name,
        elementType = '',
        emitResponse,
        billingAddress,
        onCheckoutSuccess,
        activePaymentMethod,
    }) => {

    const currentData = useRef({emitResponse, billingAddress});
    const stripe = useStripe();
    const elements = useElements();

    useEffect(() => {
        currentData.current = {...currentData.current, billingAddress, emitResponse};
    }, [emitResponse, billingAddress]);

    useEffect(() => {
        const unsubscribe = onCheckoutSuccess(async ({redirectUrl}) => {
            let args;
            if (activePaymentMethod === name) {
                if ((args = isNextActionRequired(redirectUrl))) {
                    const {billingAddress, emitResponse} = currentData.current;
                    return await handleNextAction({
                        args,
                        stripe,
                        ...(elementType !== 'expressCheckout' && {
                            elements
                        }),
                        emitResponse,
                        billingAddress
                    })
                }
            }
        });
        return unsubscribe;
    }, [
        stripe,
        elements,
        onCheckoutSuccess,
        activePaymentMethod
    ]);
}